import React from 'react';
import DashboardBreadcrumbs from 'components/dashboard/DashboardBreadcrumbs';
import {List} from 'immutable';
import './RepProfileSelector.styl';
import {RepProfileTab} from '@store/coaching-plans';
import {getStringQueryParam} from 'utils/getQueryParam';
import DashboardDateRangePicker from 'components/dashboard/date-range-picker/DashboardDateRangePicker';

export default class RepProfileSelector extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const {reps, repId} = this.props;
    if (!reps) {
      return;
    }
    if (!reps.find(rep => rep.id === repId)) {
      const firstRep = reps.get(0);
      if (firstRep) {
        setTimeout(() => this.props.onSelectRep(firstRep.id));
      }
    }
  }

  render() {
    const {reps, teams, sessionUser, startDate, endDate, rep, manager, teamId, repId, location} =
      this.props;
    const selectedTeam = teams && teams.find(team => team.id === teamId);
    const managerId = (manager && manager.id) || (sessionUser.role === 'manager' && sessionUser.id);

    const isOnCoachingPlansWithPlan =
      location &&
      location.search &&
      getStringQueryParam(location, 'tab') === RepProfileTab.COACHING_PLANS.toString() &&
      getStringQueryParam(location, 'planId');
    return (
      <div className="rep-profile-selector" style={this.props.style}>
        <div className="rep-profile-selector-content">
          <div className="user-selector">
            <DashboardBreadcrumbs
              loadData={false}
              rep={rep}
              repId={repId}
              manager={manager}
              managerId={managerId}
              adminId={sessionUser.isAdmin() && sessionUser.id}
              selectedTeam={selectedTeam}
              onSelectTeam={this.props.onSelectTeam}
              onSelectRep={this.props.onSelectRep}
              teams={List(teams).filter(team => team.manager_id === managerId)}
              users={reps}
              location={this.props.location}
              isOnCoachingPlansWithPlan={isOnCoachingPlansWithPlan}
            />
          </div>
          <DashboardDateRangePicker
            startDate={startDate}
            endDate={endDate}
            location={this.props.location}
          />
        </div>
      </div>
    );
  }
}
